export default __webpack_public_path__ + "static/media/8.98076277.jpg";